__turbopack_context__.v({
  "className": "raleway_8f18c943-module__yxFELG__className",
});
